<div [style.display]="tooltipContentDisplayStyle" #overlayOrigin="cdkOverlayOrigin" cdkOverlayOrigin>
  <sd-theme-wrapper [brand]="brand">
    <ng-content />
  </sd-theme-wrapper>
</div>

<sd-core-tooltip #coreTooltip
  [overlayOrigin]="overlayOrigin"
  [position]="position"
  [tooltipTemplate]="tooltipTemplate"
  [tooltipClass]="tooltipClass"
>
  <sd-theme-wrapper [brand]="brand">
    <ng-content select="[sd-tooltip-template]" />
  </sd-theme-wrapper>
</sd-core-tooltip>
